import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import "./Commune_Individual.css";

export const CommuneIndividual = () => {
  const { communeId } = useParams();
  const [commune, setCommune] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getCommune = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/commune/indi/${communeId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setCommune(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCommune();
  }, []);

  if (!commune) {
    return <div>Loading...</div>;
  }

  return (
    <Paper elevation={3} className="outerCont">
      <Typography variant="h4">{commune.settings.fname}'s Commune</Typography>
      <div className="innerCont">
        <Typography variant="h6"> Settings:</Typography>
        <Typography variant="subtitle1">
          First name: {commune.settings.fname}
        </Typography>
        <Typography variant="subtitle1">
          Last name: {commune.settings.lname}
        </Typography>
        <Typography variant="subtitle1">
          Contact Number: {commune.settings.number}
        </Typography>
        <Typography variant="subtitle1">
          Email: {commune.settings.email}
        </Typography>
        <Typography variant="subtitle1">
          Primary Role: {commune.settings.primary_role}
        </Typography>
        <Typography variant="subtitle1">
          Notification Status: {commune.settings.job_notification_status}
        </Typography>
        <Typography variant="subtitle1">
          Notification Type:{" "}
          {Array.isArray(commune.settings.job_notification_type)
            ? commune.settings.job_notification_type.join(", ")
            : ""}
        </Typography>
      </div>
      <div className="innerCont">
        <Typography variant="h6"> Interest:</Typography>
      </div>
      <div className="innerCont">
        <Typography variant="h6"> Questions:</Typography>
      </div>
      {/* Display other relevant commune information */}
      {/* You can access other properties of the commune schema and display them as needed */}
    </Paper>
  );
};
